export default {"src":"/_next/static/media/faq-icon7.a19c80f1.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};